import sdate from "@timclark/sdate";
import {
  Home,
  CalendarDays,
  ClipboardCheck,
  BookOpen,
  Users,
  DollarSign,
  HandCoins,
  GraduationCap,
  MessageSquare,
  ShieldCheck,
  Mail,
  BookMarked,
  ListChecks,
  BarChart3,
  TrendingUp,
  Phone,
  CalendarClock,
  Hourglass,
  Recycle,
  Search,
  Receipt,
  Banknote,
  Landmark,
  SearchCheck,
  Briefcase,
  Sun,
  Wrench,
  Package,
  Settings,
  Gem,
  Bot,
  FileText,
  Palmtree,
  Route,
  Sparkles,
  ListTodo,
  FlaskConical,
  Plus,
  BookOpenCheck,
  CheckCheck,
  TestTube,
  Map,
  HeartHandshake,
  ArrowDownUp,
  CalendarRange,
  ChartColumn,
  Bike,
  PiggyBank,
  Funnel,
  Activity,
} from "lucide-react";

/**
 * Sidebar navigation menu configuration.
 *
 * Each menu group has a title, an optional access role, and an array of items.
 * Icons are lucide-react components. The `icon` field is a React component
 * (not an instance), so the sidebar renders it as `<item.icon />`.
 *
 * @author Forge
 * @version 2.0
 * @since 2026-04-07
 */
export const menu = [
  {
    title: "Home",
    items: [
      { name: "home", href: "/", icon: Home },
      { name: "timetable", href: "/timetable", icon: CalendarDays },
      { name: "attendance", href: "/attendance", icon: ClipboardCheck },
      { name: "bookList", href: "/booklist", icon: BookOpen },
    ],
  },
  {
    title: "Admin",
    access: "Admin",
    items: [
      { name: "staff", href: `/staffshifts/${new sdate()}`, icon: Users },
      { name: "money", href: "/money", icon: DollarSign },
      { name: "owed", href: "/owed", icon: HandCoins },
      { name: "absent", href: "/absent", icon: GraduationCap },
      { name: "feedback", href: "/manage/feedback", icon: MessageSquare },
      { name: "books", href: "/admin/Books", icon: BookMarked },
      { name: "classesList", href: "/classlist", icon: ListChecks },
    ],
  },
  {
    title: "Sales",
    access: "Sales",
    items: [
      { name: "pipeline", href: "/sales/pipeline", icon: Funnel },
      { name: "messages", href: "/sales/messages", icon: Mail },
        { name: "marketing", href: "/marketing", icon: Phone },
      {
        name: "paymentFrequency",
        href: "/sales/payment-frequency",
        icon: BarChart3,
      },
      { name: "data", href: "/sales/students", icon: TrendingUp },
      {
        name: "newLost",
        href: `/newlost/today/${new sdate().year()}/${new sdate().month()}`,
        icon: ArrowDownUp,
      },
      { name: "pending", href: "pending", icon: Hourglass },
      { name: "resale", href: "/sales/resale/edu", icon: Recycle },
      { name: "stoppedSearch", href: "/sales/stopped-search", icon: Search },
    ],
  },
  {
    title: "Accounting",
    access: "Accountant",
    items: [
      { name: "salaries", href: "/manage/salaries", icon: Receipt },
      { name: "costs", href: "/manage/costs", icon: Banknote },
      { name: "financial", href: "/accounting/financial", icon: Landmark },
    ],
  },
  {
    title: "Human resources",
    access: "Human resources",
    items: [
      {
        name: "humanResources",
        href: "/manage/humanResources",
        icon: Briefcase,
      },
    ],
  },
  {
    title: "Curriculum",
    access: "Head Teacher",
    items: [
      { name: "syllabus", href: "teaching/syllabus", icon: BookMarked },
      { name: "dayPlan", href: "/tech/DayPlan", icon: Sun },
      { name: "issues", href: "/syllabus/issues", icon: Wrench },
      { name: "materials", href: "/teaching/materials", icon: Package },
    ],
  },
  {
    title: "Manage",
    access: "Manager",
    items: [
      { name: "overview", href: "manage/overview", icon: Landmark },
      { name: "staff", href: "/manage/staff", icon: Users },
      {
        name: "leaveApprovals",
        href: "/manage/leave-approvals",
        icon: CalendarClock,
      },
      { name: "costs", href: "/manage/costs", icon: Banknote },

     
      { name: "sales", href: "/manage/sales", icon: PiggyBank },
      {
        name: "pipelineReport",
        href: "/manage/pipeline-report",
        icon: Activity,
      },
      { name: "revenueToday", href: "/tech/revenue-today", icon: Gem },
      { name: "careReport", href: "/manage/care", icon: HeartHandshake },
      {
        name: "teachersReport",
        href: `/manage/teachers-report`,
        icon: FileText,
      },
      { name: "settings", href: "/manage/settings", icon: Settings },
    ],
  },
  {
    title: "Tech",
    access: "Tech",
    items: [
      { name: "routeRecord", href: "/tech/routerecord", icon: Route },
      { name: "projection", href: "/tech/projection", icon: Sparkles },
      { name: "unitReport", href: "/tech/unit-report", icon: ChartColumn },
      { name: "roadmap", href: "/tech/roadmap", icon: Map },
    ],
  },
];
